"use strict";

exports.__esModule = true;
exports.AggregateMeasureChartWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _AggregateMeasureChartElement = require("./AggregateMeasureChartElement");
var _ChartCard = require("../common/ChartCard");
var _AggregateMeasureChartFields = require("./AggregateMeasureChartFields");
var _AggregateMeasureChartThumbnail = require("./AggregateMeasureChartThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AggregateMeasureChartWidget = exports.AggregateMeasureChartWidget = {
  name: "AggregateMeasureChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AggregateMeasureChart.label",
    defaultMessage: "Aggregate Measure Chart"
  }),
  icon: "th-list",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AggregateMeasureChart",
      props: Object.assign({
        width: 300,
        height: 300,
        aggregationDefs: [{
          operation: "sum",
          fieldName: "duration"
        }],
        color: "#68ccca",
        dataRange: "",
        dataHistogram: [],
        measureChartSeries: [],
        hideYLabel: false,
        hideYAxis: false,
        hideXAxis: false,
        hideTooltip: false,
        hideXLabel: false
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 200,
      min: 256,
      max: 3840
    },
    height: {
      "default": 256,
      min: 256,
      max: 2160
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_AggregateMeasureChartElement.AggregateMeasureChartElement, function (props) {
      var first = (props.measureChartSeries || [])[0];
      return {
        title: first && (first.label || first.name || first.id) || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "AggregateMeasureChartWidget.card.title",
          defaultMessage: "Measure"
        })
      };
    }),
    Fields: _AggregateMeasureChartFields.AggregateMeasureChartFields,
    Thumbnail: _AggregateMeasureChartThumbnail.AggregateMeasureChartThumbnail
  }
};